import { render } from "./EachPrice.vue?vue&type=template&id=5bae5949"
import script from "./EachPrice.vue?vue&type=script&lang=js"
export * from "./EachPrice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__